import { AxiosInstance } from "axios"
import { DateTime } from "luxon"
import { MessageTagValue } from "../../../../modules/merchant/admin/messages/messagesTypes"

export enum NotificationQuery {
    NOTIFICATION_COUNT = "notification-count",
    NOTIFICATIONS_LIST = "notifications-list",
}

const NOTIFICATIONS_LAST_SEEN_KEY = "facilitynet.notifications.lastRead"

export type FetchNotificationCountParams = Readonly<{}>

export type FetchNotificationCountResponse = Readonly<{
    countNotifications: number
}>

export async function fetchNotificationCount(
    {}: FetchNotificationCountParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchNotificationCountResponse> {
    const url = "/client/CountNotifications"

    const lastSeen = localStorage.getItem(NOTIFICATIONS_LAST_SEEN_KEY)
    const fromDatetime = lastSeen ? DateTime.fromISO(lastSeen, { zone: "UTC" }) : DateTime.utc().minus({ years: 1 })

    const { data } = await axios.get(url, {
        params: {
            fromDatetime: fromDatetime.toISO(),
        },
        signal,
    })

    return data
}

export type FetchNotificationsParams = Readonly<{}>

export type Notification = Readonly<{
    id: number
    tag: MessageTagValue
    subject: string
    message: string
    created: string
    notificationType: string
    uid: string
}>

export type FetchNotificationsResponse = Readonly<{
    notifications: Notification[]
}>

export async function fetchNotifications(
    {}: FetchNotificationsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchNotificationsResponse> {
    const url = "/client/notifications"

    const { data } = await axios.post(
        url,
        {},
        {
            signal,
        },
    )

    localStorage.setItem(NOTIFICATIONS_LAST_SEEN_KEY, DateTime.utc().toISO())

    return data
}

